/* tslint:disable */
/* eslint-disable */
/**
 * The Thing API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    CaseFileLite,
    CaseFileLiteFromJSON,
    CaseFileLiteFromJSONTyped,
    CaseFileLiteToJSON,
    CaseFolder,
    CaseFolderFromJSON,
    CaseFolderFromJSONTyped,
    CaseFolderToJSON,
} from './';

/**
 * 
 * @export
 * @interface CaseFileSearchResult
 */
export interface CaseFileSearchResult {
    /**
     * 
     * @type {Array<CaseFileLite>}
     * @memberof CaseFileSearchResult
     */
    files: Array<CaseFileLite>;
    /**
     * 
     * @type {Array<CaseFolder>}
     * @memberof CaseFileSearchResult
     */
    folders: Array<CaseFolder>;
}

export function CaseFileSearchResultFromJSON(json: any): CaseFileSearchResult {
    return CaseFileSearchResultFromJSONTyped(json, false);
}

export function CaseFileSearchResultFromJSONTyped(json: any, ignoreDiscriminator: boolean): CaseFileSearchResult {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'files': ((json['files'] as Array<any>).map(CaseFileLiteFromJSON)),
        'folders': ((json['folders'] as Array<any>).map(CaseFolderFromJSON)),
    };
}

export function CaseFileSearchResultToJSON(value?: CaseFileSearchResult | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'files': ((value.files as Array<any>).map(CaseFileLiteToJSON)),
        'folders': ((value.folders as Array<any>).map(CaseFolderToJSON)),
    };
}


